exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-364d4f59]:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.not-allowed[data-v-364d4f59] {\n  cursor: not-allowed !important;\n}\n.cursor-pointer[data-v-364d4f59]\n{\n  cursor:pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-364d4f59","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contactPerson/ContactPersonList.vue
// module id = H2py
// module chunks = 1